import { clientTransformed } from '@common/utils/rest';
import { HttpSuccessDto } from '@common/dto/http';
import { SpreadsheetMembersRequest } from './batch-invites.types';
import { SpreadsheetTableQueryModel, SpreadsheetTableFilterModel, SpreadsheetTableWhereClause } from '../pages/spreadsheet-details/components/spreadsheet-result/components/table/table.types';

const URL_PREFIX = 'api/spreadSheets';

/**
 * Maps a SpreadsheetTableWhereClause to the format expected by the API
 */
const mapWhereClause = (clause: SpreadsheetTableWhereClause): SpreadsheetMembersRequest['queryModel']['whereClauses'][0] => {
  let stringValue = '';
  if (typeof clause.value === 'string') {
    stringValue = clause.value;
  } else if (clause.value && typeof clause.value === 'object') {
    stringValue = (clause.value as any).rawValue || (clause.value as any).dataValue || (clause.value as any).updateValue || '';
  }

  return {
    field: {
      fieldid: clause.field.fieldid,
      fieldname: clause.field.fieldcontext, 
      type: clause.field.type,
      system: clause.field.system,
      tableIndex: 0, 
      fieldClass: clause.fieldClass || '',
      fieldcontext: clause.field.fieldcontext,
    },
    operator: clause.operator,
    value: stringValue,
    andOr: clause.andOr || clause.andOR,
    leftParenthesis: clause.leftParenthesis,
    rightParenthesis: clause.rightParenthesis,
  };
};

const mapQueryModel = (queryModel: SpreadsheetTableQueryModel): SpreadsheetMembersRequest['queryModel'] => {
  return {
    whereClauses: queryModel.whereClauses.map(mapWhereClause),
  };
};

const mapFilterModel = (filterModel: SpreadsheetTableFilterModel): SpreadsheetMembersRequest['filter'] => {
  return {
    whereClauses: filterModel.whereClauses.map(mapWhereClause),
  };
};

// Get all members from current spreadsheet view

export const getAllMembersForISS = (request: SpreadsheetMembersRequest): Promise<number[]> => {
  return clientTransformed({
    path: `${URL_PREFIX}/getAllMembersForISS`,
    method: 'POST',
    entity: request,
  }).then((response: HttpSuccessDto<number[]>) => {
    return response.entity;
  });
};

// Check Family Questionnaire Eligibility

export const showFamilyQuestionnairesForMultiInvites = (globalIds: number[]): Promise<boolean> => {
  return clientTransformed({
    path: `${URL_PREFIX}/showFamilyQuestionnairesForMultiInvites`,
    method: 'POST',
    entity: globalIds,
  }).then((response: HttpSuccessDto<boolean>) => {
    return response.entity;
  });
};

/**
 * Creates a request payload for getAllMembersForISS
 * Maps frontend types to API types
 */
export const createSpreadsheetMembersRequest = (
  folderId: number,
  familyId: number = 0,
  queryModel?: SpreadsheetTableQueryModel,
  filterModel?: SpreadsheetTableFilterModel
): SpreadsheetMembersRequest => {
  const request: SpreadsheetMembersRequest = {
    folderId,
    familyId,
    queryModel: {
      whereClauses: []
    },
    filter: {
      whereClauses: []
    }
  };
  
  if (queryModel && queryModel.whereClauses && queryModel.whereClauses.length > 0) {
    request.queryModel = mapQueryModel(queryModel);
  }
  
  if (filterModel && filterModel.whereClauses && filterModel.whereClauses.length > 0) {
    request.filter = mapFilterModel(filterModel);
  }
  
  return request;
};
